import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { WindowContext } from './types';
const style = { width: '100%', height: '100%' };
export const WindowContextProvider = memo(function WindowContextProvider(props) {
    const { children } = props;
    const { width, height, ref } = useResizeDetector({
        refreshMode: 'throttle',
    });
    const is_horizontal_mobile = useMemo(() => {
        if (height && width) {
            return height <= 540 && width > 400;
        }
        return false;
    }, [height, width]);
    const window_context_content = useMemo(() => ({
        size: { height: height ?? 0, width: width ?? 0 },
        is_horizontal_mobile,
    }), [height, width, is_horizontal_mobile]);
    return (_jsx("div", { style: style, ref: ref, children: _jsx(WindowContext.Provider, { value: window_context_content, children: children }) }));
});
export const useWindow = () => useContext(WindowContext);
